import { Filter } from '@cubejs-client/core';

import { SpendType } from '~/common/types/cubes/SpendType';
import { useModuleContext } from '~/components/ModuleContextProvider';

import { CUBE, NegotiationsTotalSavingsWidget } from './NegotiationsTotalSavingsWidget';

interface SupplierNegotiationsTotalSavingsWidgetProps {
  spendType: SpendType;
}

export const SupplierNegotiationsTotalSavingsWidget = ({ spendType }: SupplierNegotiationsTotalSavingsWidgetProps) => {
  const { entityId } = useModuleContext();

  const filters: Filter[] = [
    {
      member: `${CUBE}.supplier_id`,
      operator: 'equals',
      values: [entityId],
    },
  ];

  return <NegotiationsTotalSavingsWidget filters={filters} spendType={spendType} />;
};
